import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../environments/environment';
import { BaseApiService } from './api';
import { Subject } from 'rxjs';
import { MappingFieldsRequestParamDto } from '../dto';

@Injectable({
    providedIn: 'root'
})
export class OutreachService {
    isIndividualAssignment: boolean = false;
    orDefaultOwnerIsConnectedUserToggledBeforeRelogin: boolean = false;
    private closeOutreachModalEvent = new Subject<void>();
    constructor(private readonly baseApiService: BaseApiService) { }

    authenticate(code: string): Observable<any> {
        return this.baseApiService.post('outreach/authenticate', {}, {
            params: { code: code, redirect_uri: environment.outreach.redirectUrl }
        });
    }
    logout(): any {
        return this.baseApiService.get('outreach/logout');
    }


    getSettings(): Observable<any> {
        return this.baseApiService.get('service/contactcloud/outreach/settings');
    }

    getScopes(): Observable<any> {
        return this.baseApiService.get('outreach/scopes')
    }

    getMappingFields(params: MappingFieldsRequestParamDto = {}): Observable<any> {
        const requestParams = params.isAutomation ? { is_automation: true } : {};
        return this.baseApiService.get('service/contactcloud/outreach/fields', { params: requestParams });
    }

    saveSettings(payload: any): Observable<any> {
        return this.baseApiService.post('outreach/settings', payload);
    }

    saveSettingsData(payload: any): Observable<any> {
        return this.baseApiService.put('service/contactcloud/outreach/settings', payload);
    }

    processAccounts(matchIds) {
        return this.baseApiService.post('service/contactcloud/outreach/getAccounts', {
            ids: matchIds
        });
    }

    setCadence() {
        return this.baseApiService.get(`salesloft/cadences`);
    }

    getSequences(): Observable<any> {
        return this.baseApiService.get('outreach/sequences');
    }

    getMailBoxes(): Observable<any> {
        return this.baseApiService.get('outreach/mailboxes');
    }

    getContactOwners(id: number): Observable<any> {
        return this.baseApiService.get(`outreach/contactOwners?userId=${id}`);
    }

    validateDuplicates(matchIds) {
        return this.baseApiService.post('service/contactcloud/outreach/duplicate', {
            ids: matchIds
        });
    }

    exportV2Batch(tagArray, mailbox, sequence, duplicateResolution, toBeExported, selectedContactOwner) {
        return this.baseApiService.post('service/contactcloud/outreach/exportV2', {
            tags: tagArray,
            mailBox: mailbox,
            sequences: sequence,
            duplicateResolution: duplicateResolution === 'skip' ? '' : duplicateResolution,
            ids: toBeExported,
            prospectOwner: selectedContactOwner ? Number(selectedContactOwner) : selectedContactOwner,
        });
    }
    exportV2(tagArray, mailbox, duplicateResolution, toBeExported, selectedContactOwner) {
        return this.baseApiService.post('service/contactcloud/outreach/exportV2', {
            tags: tagArray,
            mailBox: mailbox,
            duplicateResolution: duplicateResolution === 'skip' ? '' : duplicateResolution,
            ids: toBeExported,
            prospectOwner: selectedContactOwner ? Number(selectedContactOwner) : selectedContactOwner,
        });
    }

    refreshToken(): any {
        return this.baseApiService.post(`outreach/refreshToken`);
    }

    getCloseOutreachModalEvent(): Observable<void> {
        return this.closeOutreachModalEvent.asObservable();
    }
    emitCloseOutreachModalEvent(): void {
        this.closeOutreachModalEvent.next();
    }
}
